import type { ModelingFormat } from 'balus-common';

// 付箋テキストのレイアウト（＝収まる文字数）を決めるスタイル定義。
// フォントサイズの自動調整では実DOMの高さを計測して収まり具合を判定するため、
// NodeTextarea の表示と計測用要素(measureNodeTextHeight)で同じ定義を共有する必要がある。

export const nodeTextareaClass =
  'hidden-scrollbar m-2 resize-none border-none bg-transparent align-middle font-bold outline-none';

// 親要素の幅から左右のマージン(m-2 = 8px * 2)を差し引いた幅
export const nodeTextareaWidth = 'calc(100% - 16px)';

export function nodeTextareaLineBreakClass(modelingFormat: ModelingFormat): string {
  return modelingFormat === 'LATIN'
    ? 'whitespace-break-spaces break-normal break-words hyphens-auto'
    : 'whitespace-break-spaces break-all';
}

// LATIN では hyphens-auto を効かせるために lang 属性が必要になる
export function nodeTextareaLang(modelingFormat: ModelingFormat): string | undefined {
  return modelingFormat === 'LATIN' ? 'en' : undefined;
}
